import addFiles from "./addFiles/addFiles";
import post from "./post/post";
import validate from "./validate/validate";
import antispam from "./antispam/antispam";

const forms = ({
  formSelector = `.js-form`,
  enabledValidation = true,
  enabledAddFiles = true,
  enabledPost = true,
  enabledAddAdditionalInputs = false,
  isApplication = false,
  isCertificate = false,
  isStockSubscribe = false,
  isPartnersForm = false,
  enableCustomSelect = false,
  confirmReset = false,
  inputErrorClass = `error`,
  enabledAntispam = false,
  enabledCaptcha = false,
  formType = null,
}) => {
  const formsElements = document.querySelectorAll(formSelector);

  if (formsElements.length) {
    formsElements.forEach((form) => {
      const submitButtonElement = form.querySelector(`.js-submit`);

      const state = {
        url: form.action,
        isActive: false,
        validate: {
          text: true,
          radio: false,
          addAdditionalInputs: enabledAddAdditionalInputs,
          isCustomSelect: enableCustomSelect,
        },
        files: [],
        isCertificate,
        isApplication,
        isStockSubscribe,
        isPartnersForm,
        enabledCaptcha,
        confirmReset,
        captcha: {
          token: null,
          type: formType,
        },
      };

      if (enabledAntispam) {
        antispam({form});
      }

      if (enabledValidation) {
        validate({form, state, submitButton: submitButtonElement, inputErrorClass});
      }
      if (enabledAddFiles) {
        addFiles({form, state});
      }
      if (enabledPost) {
        post({form, state, submitButton: submitButtonElement});
      } else {
        form.addEventListener(`submit`, (evt) => {
          if (!state.isActive) {
            evt.preventDefault();
          } else {
            evt.stopPropagation();
          }
        });
      }
    });
  }
};

export default forms;
